module.exports = __webpack_public_path__ + "img/keeLiteLogoWithTagline.c49e9d2a.png";